// extracted by mini-css-extract-plugin
export default {"reviewContainer":"Container_reviewContainer__n0zhH"};